import { render, staticRenderFns } from "./JoinProject.vue?vue&type=template&id=3faec680&scoped=true&"
import script from "./JoinProject.vue?vue&type=script&lang=js&"
export * from "./JoinProject.vue?vue&type=script&lang=js&"
import style0 from "./JoinProject.vue?vue&type=style&index=0&id=3faec680&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3faec680",
  null
  
)

component.options.__file = "JoinProject.vue"
export default component.exports